export const useAdminAuth = () => {
  const user = localStorage.getItem('adminUser')
  return {
    isAuthenticated: !!user,
    user: user ? JSON.parse(user) : null,
  }
}
